<template>
  <div :id="`question-${question.id}`">
    <a class="d-block" target="_blank" v-if="question.text_id" :href="`/text/${question.text_id}`"
      >წაიკითხეთ ტექსტი აქ</a
    >
    <h3 v-html="`<span>${number}.</span>${question.question}`" class="kitxva" />

    <div class="option-wrapper pb-2">
      <div
        v-for="(option, index) in question.options"
        :key="`${option.id}-${index}`"
        class="option-label-wrapper"
        :class="{ timeline: question.type_id === 2 }"
      >
        <input
          type="radio"
          name="customRadio"
          required="required"
          v-if="question.type_id != 2"
          :id="'customRadio-' + option.id"
          :value="option"
          @input="onSelect(option)"
        />
        <label
          class="option"
          :class="getQuestionClasses(option)"
          v-if="question.type_id != 2"
          :for="'customRadio-' + option.id"
          v-html="option.option"
        ></label>

        <!-- timeline options -->
        <div
          :class="getQuestionTimelineClass(option)"
          class="option timeline-option"
          v-if="question.type_id == 2"
        >
          <input
            @keypress="isNumber"
            type="text"
            class="form-control timeline-input"
            v-model="timeline[option.id]"
            @input="onTimelineSelect"
            required="required"
            :disabled="userAnswer"
          />
          <input
            v-if="userAnswer"
            class="form-control timeline-input border-success"
            :value="option.timeline"
            disabled
          />
          <div v-html="option.option"></div>
        </div>
      </div>
    </div>
    <hr v-if="showDivder" />
  </div>
</template>

<script>
export default {
  props: ['question', 'userAnswer', 'number', 'oneQuestionMode', 'showDivder'],
  data() {
    return {
      isCorrect: false,
      timeline: this.userAnswer || {},
    };
  },
  methods: {
    onSelect(option) {
      this.$emit('onSelect', option);
    },
    onTimelineSelect() {
      this.$emit('onTimelineSelect', this.timeline, this.question);
    },
    getQuestionClasses(option) {
      return {
        'correct-answer': this.userAnswer && option.correct,
        'wrong-answer': this.userAnswer && !option.correct && option.id === this.userAnswer.id,
      };
    },
    getQuestionTimelineClass(option) {
      let classNames = {
        'correct-answer':
          this.userAnswer &&
          this.userAnswer[option.id] &&
          option.timeline == this.userAnswer[option.id],
        'wrong-answer':
          this.userAnswer &&
          this.userAnswer[option.id] &&
          option.timeline != this.userAnswer[option.id],
      };

      return classNames;
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        evt.target.value = '';
        return true;
      }
    },
  },

  mounted() {
    this.timeline = this.userAnswer || {};
  },
};
</script>
